var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"event-list-page"},[_c('div',{staticClass:"go-back"},[_c('el-button',{staticClass:"row go-back-btn",attrs:{"icon":"el-icon-arrow-left"},on:{"click":_vm.goBack}})],1),_c('div',{staticClass:"body"},[_c('div',{staticClass:"title"},[_vm._v("热门事件")]),_c('event-list',{staticClass:"event-list",on:{"change":_vm.sourceHome}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }